import { createSelector } from 'reselect';

const getState = (state) => state.shipperOrderEdit;

const isBreakModalOpened = createSelector(getState, (state) => state.breakModalOpened);
const isCancelModalOpened = createSelector(getState, (state) => state.cancelModalOpened);
const getBreakModalMode = createSelector(getState, (state) => state.breakModalMode);
const getCancellationQuote = createSelector(getState, (state) => state.cancellationQuote);

export { isBreakModalOpened, isCancelModalOpened, getBreakModalMode, getCancellationQuote };
